import { createReducer, on } from '@ngrx/store';
import {
  DUAL_PRICING_FIND_SUCCESS,
  DUAL_PRICING_FAILURE,
  DUAL_PRICING_RESET,
  DUAL_PRICING_FIND_ALL_SUCCESS,
  DUAL_PRICING_CLEAR_STATE,
  DUAL_PRICING_UPDATE_LOADING,
} from '../actions';
import { IResponseBadRequest } from '@core/interfaces';
import { DualPricing } from '@core/models';

export interface DualPricingState {
  loading: boolean;
  dualPricing: DualPricing | null;
  dualPricingId: string | null;
  dualPricingList: DualPricing[] | null;
  error: IResponseBadRequest | null;
}

export const initialState: DualPricingState = {
  loading: false,
  dualPricing: null,
  dualPricingId: null,
  dualPricingList: null,
  error: null,
};

export const dualPricingReducer = createReducer(
  initialState,
  on(DUAL_PRICING_FIND_SUCCESS, (state, { dualPricing }) => ({ ...state, dualPricing })),
  on(DUAL_PRICING_FIND_ALL_SUCCESS, (state, { dualPricingList }) => ({ ...state, dualPricingList })),
  on(DUAL_PRICING_FAILURE, (state, { error }) => ({ ...state, error })),
  on(DUAL_PRICING_RESET, (state) => ({ ...state, dualPricing: null })),
  on(DUAL_PRICING_CLEAR_STATE, () => initialState),
  on(DUAL_PRICING_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading }))
);
